import * as React from "react";
import { isFontOutlines } from "../../../constants/IdFontWithOutlines";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { FontWithOutline } from "../font-with-outline/FontWithOutline";
export var CurrencyFormat = function (_a) {
    var amount = _a.amount, className = _a.className, currencyCode = _a.currencyCode;
    var locaOptions = utilLoca.getOptions();
    if (locaOptions.convertToSymbols) {
        return React.createElement(React.Fragment, null, "$$$");
    }
    var currencyText = utilNumber.formatCurrency(amount, currencyCode);
    if (isFontOutlines(className)) {
        return React.createElement(FontWithOutline, { style: className }, currencyText);
    }
    return React.createElement("span", { className: className }, currencyText);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/currency-format/CurrencyFormat.tsx
// module id = 960
// module chunks = 3